import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "reactstrap";
import { useSchedule } from "../../context/ScheduleContext";
import CreateSchedulerFirstTab from "./CreateSchedulerFirstTab";
import CreateSchedulerSecondTab from "./CreateSchedulerSecondTab";
import CreateSchedulerThirdTab from "./CreateSchedulerThirdTab";

type CreateSchedulerNavBarType = {
    childrenColumnSize?: number;
    onFetchData: () => void;
};

export function CreateSchedulerNavBar({ childrenColumnSize = 12, ...props }: CreateSchedulerNavBarType) {
    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);

    const { scheduleDTO, setScheduleDTO } = useSchedule();

    const resetScheduleFields = () => {
        setScheduleDTO({
            assistanceId: null,
            assistanceName: null,
            clientErpId: null,
            clientName: null,
            equipmentErpId: null,
            equipmentCarPlateName: null,
            equipmentSerialNumberName: null,
            equipmentBrandName: null,
            equipmentModelName: null,
            equipmentSkuName: null,
            checkinStartDate: null,
            checkinEndDate: null,
            checkinNotes: null,
            checkinTechnicianId: null,
            executionStartDate: null,
            executionEndDate: null,
            executionNotes: null,
            executionTechnicianId: null,
            type: null
        });
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const handleCreateSchedule = () => {
        props.onFetchData();
        resetScheduleFields();
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.CreateScheduler.Navbar.FirstTab" })} {...a11yProps(0)} />
                    <Tab label={intl.formatMessage({ id: "Screens.CreateScheduler.Navbar.SecondTab" })} {...a11yProps(1)} />
                    <Tab label={intl.formatMessage({ id: "Screens.CreateScheduler.Navbar.ThirdTab" })} {...a11yProps(2)} />
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <CreateSchedulerFirstTab
                    scheduleDTO={scheduleDTO}
                    setScheduleDTO={setScheduleDTO}
                    onFetchData={handleCreateSchedule}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={1} childrenColumnSize={childrenColumnSize}>
                <CreateSchedulerSecondTab
                    scheduleDTO={scheduleDTO}
                    setScheduleDTO={setScheduleDTO}
                    onFetchData={handleCreateSchedule}
                />
            </TabPanel>

            <TabPanel value={activeTab} index={2} childrenColumnSize={childrenColumnSize}>
                <CreateSchedulerThirdTab
                    scheduleDTO={scheduleDTO}
                    setScheduleDTO={setScheduleDTO}
                    onFetchData={handleCreateSchedule}
                />
            </TabPanel>
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}